module.exports = __webpack_public_path__ + "img/check.aacc7b1b.png";